<template>
<div class="d-flex flex-column align-center">
  <div class="EnvelopeTemplatesDialogNoData-icon mb-6">
    <app-material-icon name="draft" />
  </div>
  <div class="mb-6 text-text-secondary">{{$t('project.signing-checklist.envelope-templates.EnvelopeTemplatesNoData.noEnvelopeTemplates')}}</div>
  <AppButton v-if="isSubPayingUser"
             type="primary"
             @click="navigateToEnvelopeTemplateCreation"
  >
    <template #left-icon>
      <app-material-icon name="add" color="icon-inverted" class="mr-2"  />
    </template>
    {{$t('project.signing-checklist.envelope-templates.EnvelopeTemplatesNoData.createEnvelopeTemplate')}}
  </AppButton>
</div>
</template>

<script>
import { mapGetters } from 'vuex'

import AppButton from '@/design-system/buttons/AppButton.vue'
import { ENVELOPE_TEMPLATE_ADD_ROUTE_NAME } from '@/router/routerData'

export default {
  name: 'EnvelopeTemplatesNoData',
  components: { AppButton },
  computed: {
    ...mapGetters('user', ['isSubPayingUser']),
  },
  methods: {
    navigateToEnvelopeTemplateCreation () {
      this.$router.push({ name: ENVELOPE_TEMPLATE_ADD_ROUTE_NAME })
    },
  },
}
</script>

<style scoped lang="scss">
@import "@/scss/border-tokens";

.EnvelopeTemplatesDialogNoData {
  &-icon {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 64px;
    height: 64px;
    background-color: rgb(var(--v-theme-surface-tertiary));
    @include border-radius('border-radius-circle');
  }
}
</style>
